import {
    ONLINE_BOOKING_NAVIGATE_TO_STEP,
    OnlineBookingAction
} from 'actions/onlineBooking/OnlineBookingActionsTypes';
import { Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';
import { getBusinessArea, trackStepView } from 'utils/analytics';

export const analyticsMiddleware: Middleware =
    ({ getState }: MiddlewareAPI<Dispatch<RootAction>, RootState>) =>
    (dispatch: Dispatch<RootAction>) =>
    (action: OnlineBookingAction) => {
        const result = dispatch(action);

        if (action.type === ONLINE_BOOKING_NAVIGATE_TO_STEP) {
            const state = getState();
            const { id, slug } = state.marketplace.data;

            trackStepView({
                step_name: action.payload.step,
                marketplace_id: id,
                marketplace_slug: slug,
                business_area: getBusinessArea(state.onlineBooking.bookingItems),
                is_returning_client: !state.onlineBooking.customer.lead
            });
        }

        return result;
    };
